import React, { useEffect, useState,useRef } from "react";
import { CSVLink } from "react-csv";
import { BrandsTypes, toLakhs } from "../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import Select from "react-select";
import { SlDrawer, SlSwitch } from "@shoelace-style/shoelace/dist/react";
import ScrollContainer from "react-indiana-drag-scroll";
import SheetTwoLoader from "./SheetTwoLoader";
import TableLoader from "../../../shared/TableLoader";
import NoDataFound from "../../../shared/NoDataFound";
import useCategories from "../useCategories";
const SheetTwoPreview = ()=>{
  const now = new Date();
  const currentYear = now.getFullYear();
  
  // Start of current year (Jan 1, 00:00:00)
  const startOfThisYear = new Date(currentYear, 0, 1);
  startOfThisYear.setHours(0, 0, 0, 0);
  
  // End of current year (Dec 31, 23:59:59)
  const endOfThisYear = new Date(currentYear, 11, 31);
  endOfThisYear.setHours(23, 59, 59, 999);
  
  // Start of previous year (Jan 1, 00:00:00)
  const startOfLastYear = new Date(currentYear - 1, 0, 1);
  startOfLastYear.setHours(0, 0, 0, 0);
  
  // End of previous year (Dec 31, 23:59:59)
  const endOfLastYear = new Date(currentYear - 1, 11, 31);
  endOfLastYear.setHours(23, 59, 59, 999);
  
  const [MonthRange, setMonthRange] = useState([startOfThisYear, endOfThisYear]);
  const [compareMonthRange, setcompareMonthRange] = useState([startOfLastYear, endOfLastYear]);
  const {CategorySelect, selectedCategories} = useCategories()
  // Rows are grouped by region by default; the switch swaps the dimension to category.
  const [groupByCategory, setGroupByCategory] = useState(false);
  const groupLabel = groupByCategory ? "Category" : "Region";
  
    const [brandtype,setbrandtype] = useState(2);//local-telugu
    const [salesList, setsalesList] = useState([]);
    const [salesId, setsalesId] = useState([]);
    const [ data, setData] = useState({});   
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [Locations, setLocations] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const csvLinkRef = useRef(null);
    const brandCsvLinkRef = useRef(null);
    // Brand-wise drill-down: { label, value } - a null value means "all rows"
    const [drilldown, setDrilldown] = useState(null);
    const [brandData, setBrandData] = useState([]);
    const [isBrandLoading, setIsBrandLoading] = useState(false);
    const formatMonthRangeLabel = (range) => {
      if (!range || range.length === 0 || !range[0]) return "";
    
      const start = new Date(range[0]);
      const end = new Date(range[1] || range[0]);
    
      const format = (d) =>
        d.toLocaleString("en-US", { month: "short", year: "numeric" }); // e.g. "Jan 2024"
    
      if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
        return format(start); // single month (e.g. "Apr 2025")
      }
    
      return `${format(start)} - ${format(end)}`; // range (e.g. "Jan 2024 - Jul 2024")
    };
    
    const getSales = async () => {
      try {
        let res = await API({
          url:"/planning/getSales",
          method:'POST',
          responseType:'json',
          data:{
            type:brandtype
          }
        })
        if(res.code === 200){
          const formatted = res.data.map((item) => ({
            value: item.sales_person_id,
            label: item.name
          }));
          setsalesList(formatted)
        }
      } catch (error) {
        console.error(error);
      }
    }
    const handleFetch = async () => {
        try {
          const result = await API({
            url: "/phionex_reports/getSheet2Data",
            method: "POST",
            data: { 
                selectedmonth: MonthRange,
                comparemonth: compareMonthRange,
                region:selectedLocation,
                brand_type:brandtype,
                salesId:salesId.length > 0 ? salesId : null,
                selectedCategories,
                groupBy: groupByCategory ? "category" : "region"
             },
          });
          if (result.status === "SUCCESS") {
            return result.data;
          } else {
            Toast("error", result?.message || "Failed To Fetch Data");
            return {};
          }
        } catch (error) {
          Toast("error", "An error occurred");
          return {};
        }
      };
    const openBrandBreakdown = async (label, value = label) => {
      setDrilldown({ label, value });
      setBrandData([]);
      setIsBrandLoading(true);
      try {
        const result = await API({
          url: "/phionex_reports/getSheet2BrandWise",
          method: "POST",
          data: {
            selectedmonth: MonthRange,
            comparemonth: compareMonthRange,
            region: selectedLocation,
            brand_type: brandtype,
            salesId: salesId.length > 0 ? salesId : null,
            selectedCategories,
            groupBy: groupByCategory ? "category" : "region",
            groupValue: value
          },
        });
        if (result.status === "SUCCESS") setBrandData(result.data || []);
        else Toast("error", result?.message || "Failed To Fetch Brand Breakdown");
      } catch (error) {
        Toast("error", "An error occurred");
      } finally {
        setIsBrandLoading(false);
      }
    };

    useEffect(() => {
        const fetchLocations = async () => {
          const result = await API({
            url: "/phionex_reports/brandLocations",
            method: "POST",
          });
    
          if (result.status === "SUCCESS") {
            setLocations(result.data || []);
          } else Toast("error", "Failed To Get Locations");
        };
        fetchLocations();
    }, []);
    useEffect(()=>{
      if(brandtype)
      {
        getSales();
      }
      else
      {
        setsalesId([]);
        setsalesList([]);
      }
    },[brandtype])
    useEffect(() => {
        const fetchData = async () => {
          setIsLoading(true);
          const result = await handleFetch()
          setData(result);
          setIsLoading(false);
        };
        fetchData();
    }, [MonthRange,compareMonthRange,brandtype,selectedLocation,salesId,selectedCategories,groupByCategory]);


      const calculateGrowth = (prev, curr) => {
        if (prev === 0 || curr === 0) return "-"
        return Math.round(((curr - prev) / prev) * 100); // standard % growth
      };

      const handlePrepareCSV = () => {
        if (!data || data.length === 0) return;
      
        const compareLabel = formatMonthRangeLabel(compareMonthRange);
        const selectedLabel = formatMonthRangeLabel(MonthRange);
      
        const totalCompare = data.reduce((sum, r) => sum + (r.compare || 0), 0);
        const totalSelected = data.reduce((sum, r) => sum + (r.selected || 0), 0);
        const totalGrowth = calculateGrowth(totalCompare, totalSelected);
      
        const csvRows = data.map(({ label, region, compare, selected }) => ({
          [groupLabel]: label ?? region,
          [`W2N Spent (${compareLabel})`]: compare,
          [`W2N Spent (${selectedLabel})`]: selected,
          "Total Growth (%)": calculateGrowth(compare, selected),
        }));
      
        csvRows.push({
          [groupLabel]: "Total",
          [`W2N Spent (${compareLabel})`]: totalCompare,
          [`W2N Spent (${selectedLabel})`]: totalSelected,
          "Total Growth (%)": totalGrowth,
        });
      
        setCsvData(csvRows);
      };
      
      useEffect(() => {
        if (csvData.length > 0) {
          csvLinkRef.current.link.click();
          setCsvData([]); // reset to prevent repeated downloads
        }
      }, [csvData]);
    return(
        <div>
          <div className="flex flex-wrap gap-6 items-end rounded px-4 py-2 bg-white">
            <div className="flex flex-col">
              <label className="mb-1 font-semibold">Select Month</label>
              <DatePicker
                selected={MonthRange[0]}
                onChange={(update) => setMonthRange(update)}
                startDate={MonthRange[0]}
                endDate={MonthRange[1]}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                selectsRange
                className="border rounded px-3 py-2 w-48"
                maxDate={new Date()}
                placeholderText="Select Month & Year"
              />
            </div>

            <div className="flex flex-col">
              <label className="mb-1 font-semibold">Compare Month</label>
              <DatePicker
                selected={compareMonthRange[0]}
                onChange={(update) => setcompareMonthRange(update)}
                startDate={compareMonthRange[0]}
                endDate={compareMonthRange[1]}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                selectsRange
                className="border rounded px-3 py-2 w-48"
                maxDate={new Date()}
                placeholderText="Select Month & Year"
              />
            </div>

            <div className="flex flex-col min-w-[180px]">
              <label className="mb-1 font-semibold">Select Location</label>
              <Select
                options={Locations}
                value={Locations.find((loc) => loc.value === selectedLocation) || null}
                onChange={(option) => setSelectedLocation(option ? option.value : null)}
                placeholder="Select Location"
                isClearable
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="flex flex-col min-w-[180px]">
              <label className="mb-1 font-semibold">Select Brand Type</label>
              <Select
                placeholder="Select Brand Type"
                value={BrandsTypes.find((option) => option.value === brandtype) || null}
                onChange={(selected) => {
                  setbrandtype(selected ? selected.value : null);
                }}
                options={BrandsTypes}
                isClearable
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className={`flex flex-col min-w-[220px] ${brandtype ? "" : "opacity-50 pointer-events-none"}`}>
              <label className="mb-1 font-semibold">Select Sales Person(s)</label>
              <Select
                placeholder="Select Sales Person(s)"
                options={salesList}
                value={salesList.filter((opt) => salesId?.includes(opt.value))}
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  setsalesId(values);
                }}
                isMulti
                isClearable
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <CategorySelect />

            <div className="flex flex-col justify-end pb-2">
              <SlSwitch
                checked={groupByCategory}
                onSlChange={(e) => setGroupByCategory(e.target.checked)}
              >
                Category Wise
              </SlSwitch>
            </div>

            <CSVLink
              data={csvData}
              filename={`phionex_reports_sheet2.csv`}
              className="hidden"
              ref={csvLinkRef}
            />

            {data && data.length > 0 && (
              <button
                onClick={handlePrepareCSV}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Download CSV
              </button>
            )}
          </div>
       <ScrollContainer>
          <div className="space-y-2 mb-25">
            <div className="w-full flex items-center justify-center space-x-8">
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f4f4f4", textAlign: "left" }}>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>{groupLabel}</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>W2N Compare Spent ({formatMonthRangeLabel(compareMonthRange)})</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>W2N Selected Spent ({formatMonthRangeLabel(MonthRange)})</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Total Growth (%)</th>
                </tr>
              </thead>
              {!isLoading && data && data.length > 0 ? (<tbody>
                {data.map(({ label, region, compare, selected }) => {
                  const growth = calculateGrowth(compare, selected);
                  const rowLabel = label ?? region;

                  return (
                    <tr key={rowLabel}>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{rowLabel}</td>
                      <td
                        style={{ padding: "8px", border: "1px solid #ddd", color: "#2a78d6", cursor: "pointer", textDecoration: "underline" }}
                        title={`${compare} - click for brand wise breakdown`}
                        onClick={() => openBrandBreakdown(rowLabel)}
                      >
                        {toLakhs(compare)}
                      </td>
                      <td
                        style={{ padding: "8px", border: "1px solid #ddd", color: "#2a78d6", cursor: "pointer", textDecoration: "underline" }}
                        title={`${selected} - click for brand wise breakdown`}
                        onClick={() => openBrandBreakdown(rowLabel)}
                      >
                        {toLakhs(selected)}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color:
                            growth === "-" ? "black" : growth >= 0 ? "green" : "red",
                        }}
                      >
                        {growth === "-" ? "-" : `${growth}%`}
                      </td>
                    </tr>
                  );
                })}
                {(() => {
                  const totalCompare = data.reduce((sum, r) => sum + (r.compare || 0), 0);
                  const totalSelected = data.reduce((sum, r) => sum + (r.selected || 0), 0);
                  const totalGrowth = calculateGrowth(totalCompare, totalSelected);

                  return (
                    <tr
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontWeight: "bold",
                        borderTop: "2px solid #aaa",
                      }}
                    >
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>Total</td>
                      <td
                        style={{ padding: "8px", border: "1px solid #ddd", color: "#2a78d6", cursor: "pointer", textDecoration: "underline" }}
                        title={`${totalCompare} - click for brand wise breakdown`}
                        onClick={() => openBrandBreakdown("Total", null)}
                      >
                        {toLakhs(totalCompare)}
                      </td>
                      <td
                        style={{ padding: "8px", border: "1px solid #ddd", color: "#2a78d6", cursor: "pointer", textDecoration: "underline" }}
                        title={`${totalSelected} - click for brand wise breakdown`}
                        onClick={() => openBrandBreakdown("Total", null)}
                      >
                        {toLakhs(totalSelected)}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          color:
                            totalGrowth === "-" ? "black" : totalGrowth >= 0 ? "green" : "red",
                        }}
                      >
                        {totalGrowth === "-" ? "-" : `${totalGrowth}%`}
                      </td>
                    </tr>
                  );
                })()}
              </tbody>)
              : !isLoading && data && data.length === 0 ? (
                <NoDataFound colspan="4" />
            ) : (
                <TableLoader colspan="4"/>
            )}
            </table>
            </div>
          </div>
          </ScrollContainer>

        <SlDrawer
          open={Boolean(drilldown)}
          label={`Brand Wise - ${drilldown?.label ?? ""}`}
          onSlAfterHide={() => {
            setDrilldown(null);
            setBrandData([]);
          }}
          style={{ "--size": `${window.innerWidth <= 767 ? "100%" : "55%"}` }}
        >
          <div style={{ padding: "1rem" }}>
            <div className="text-sm text-gray-600 mb-3">
              {groupLabel}: <span className="font-semibold">{drilldown?.label}</span> &nbsp;|&nbsp; Compare{" "}
              {formatMonthRangeLabel(compareMonthRange)} vs Selected {formatMonthRangeLabel(MonthRange)}
            </div>

            {brandData.length > 0 && (
              <div style={{ marginBottom: "1rem", textAlign: "right" }}>
                <sl-icon-button
                  library="lucide"
                  name="download"
                  title="Download CSV"
                  onClick={() => brandCsvLinkRef.current?.link?.click()}
                  style={{ fontSize: "18px" }}
                ></sl-icon-button>
                <CSVLink
                  data={brandData.map((brand) => ({
                    [groupLabel]: drilldown?.label,
                    "Brand Name": brand?.brand_name || "-",
                    "Brand Location": brand?.brand_location || "-",
                    Category: brand?.category_name || "-",
                    [`W2N Spent (${formatMonthRangeLabel(compareMonthRange)})`]: brand?.compare ?? 0,
                    [`W2N Spent (${formatMonthRangeLabel(MonthRange)})`]: brand?.selected ?? 0,
                    "Total Growth (%)": calculateGrowth(brand?.compare, brand?.selected),
                  }))}
                  filename={`phionex_reports_sheet2_brandwise.csv`}
                  ref={brandCsvLinkRef}
                  style={{ display: "none" }}
                />
              </div>
            )}

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#f4f4f4", textAlign: "left" }}>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>S.No</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Brand Name</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Location</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Category</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Compare Spent</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Selected Spent</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Growth (%)</th>
                </tr>
              </thead>
              {isBrandLoading ? (
                <TableLoader colspan="7" />
              ) : brandData.length === 0 ? (
                <NoDataFound colspan="7" />
              ) : (
                <tbody>
                  {brandData.map((brand, index) => {
                    const growth = calculateGrowth(brand?.compare, brand?.selected);
                    return (
                      <tr key={`${brand?.brand_id || "brand"}-${index}`}>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{index + 1}</td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }} title={brand?.brand_name}>
                          {brand?.brand_name || "-"}
                        </td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{brand?.brand_location || "-"}</td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{brand?.category_name || "-"}</td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }} title={brand?.compare}>
                          {toLakhs(brand?.compare)}
                        </td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }} title={brand?.selected}>
                          {toLakhs(brand?.selected)}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            fontWeight: "bold",
                            color: growth === "-" ? "black" : growth >= 0 ? "green" : "red",
                          }}
                        >
                          {growth === "-" ? "-" : `${growth}%`}
                        </td>
                      </tr>
                    );
                  })}
                  {(() => {
                    const totalCompare = brandData.reduce((sum, r) => sum + (r.compare || 0), 0);
                    const totalSelected = brandData.reduce((sum, r) => sum + (r.selected || 0), 0);
                    const totalGrowth = calculateGrowth(totalCompare, totalSelected);
                    return (
                      <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold", borderTop: "2px solid #aaa" }}>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }} colSpan="4">
                          Total
                        </td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }} title={totalCompare}>
                          {toLakhs(totalCompare)}
                        </td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }} title={totalSelected}>
                          {toLakhs(totalSelected)}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            color: totalGrowth === "-" ? "black" : totalGrowth >= 0 ? "green" : "red",
                          }}
                        >
                          {totalGrowth === "-" ? "-" : `${totalGrowth}%`}
                        </td>
                      </tr>
                    );
                  })()}
                </tbody>
              )}
            </table>
          </div>
        </SlDrawer>
        </div>
    )
}
export default SheetTwoPreview;